import styled from '@emotion/styled';

export const PopupIllustrationImage = styled.img`
  object-fit: cover;
  width: 300px;
  height: 250px;
`;
